export default "__VITE_ASSET__CRd4UwW5__"